export const SyncValueProxyMixin = (options = {}) => {
    const { prop, propName = 'value', proxyName = 'proxyValue' } = options;
    let { model = true } = options;

    if (model) {
        model = typeof model === 'object' ? model : { prop: propName, event: 'change' };
    }

    const temp = {
        props: {
            [propName]: prop,
        },
        computed: {
            [proxyName]: {
                get() {
                    return this[propName];
                },
                set(val) {
                    if (model) {
                        this.$emit(model.event, val);
                    }
                    this.$emit(`update:${propName}`, val);
                },
            },
        },
    };

    if (model) {
        temp.model = model;
    }

    return temp;
};
